var React = require('react');

function Pencil (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.8155 0.195068C15.1265 0.195068 14.4754 0.536881 13.9328 1.07402L2.66382 12.2833L0.781128 17.9206L6.41834 16.0433L6.53771 15.9294L17.6982 4.8394C18.2353 4.29683 18.5717 3.64576 18.5717 2.95671C18.5717 2.26765 18.2353 1.61658 17.6982 1.07402C17.1556 0.536881 16.5046 0.195068 15.8155 0.195068ZM15.1089 1.89738C15.4997 1.50989 16.1302 1.51099 16.5196 1.89985L16.8689 2.24866C17.2603 2.63946 17.2601 3.27376 16.8685 3.66434L5.66961 14.8334L2.9785 15.7286L3.87915 13.0321L15.1089 1.89738Z","fill":"black"}));
}

Pencil.defaultProps = {"width":"19","height":"18","viewBox":"0 0 19 18","fill":"none"};

module.exports = Pencil;

Pencil.default = Pencil;
